import { Component } from '@angular/core';
import { AppConfig } from '../../../config/appConfig';

interface WorkflowStep {
  icon: string;
  title: string;
  description: string;
  outcome: string;
}

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrl: './how-it-works.component.css'
})
export class HowItWorksComponent {
  title = AppConfig.title;

  readonly steps: WorkflowStep[] = [
    {
      icon: 'bi bi-person-plus',
      title: 'Create your operating account',
      description: `Start with a secure account, establish your active workspace, and choose the subscription path that matches the scale of your operation.`,
      outcome: 'You move from scattered personal notes to a structured operational environment.'
    },
    {
      icon: 'bi bi-water',
      title: 'Build your fleet profile',
      description: `Add your boats with the details that actually matter in day-to-day execution: specifications, documents, engine details, sails, fluids, identifiers, and readiness context.`,
      outcome: 'Every boat becomes a live operational record, not just a static listing.'
    },
    {
      icon: 'bi bi-clipboard-check',
      title: 'Standardize maintenance and compliance',
      description: `Create worklogs, attach files, generate maintenance plans, manage inventory, and run checklists with completion tracking and exportable records.`,
      outcome: 'The operation becomes more disciplined, more auditable, and much harder to derail.'
    },
    {
      icon: 'bi bi-compass',
      title: 'Plan smarter trips',
      description: `Prepare cruises, assign crew and passengers, maintain people lists, save routes, analyze routes, and use nautical map tools before a trip leaves the dock.`,
      outcome: 'Trips start with clarity instead of assumptions.'
    },
    {
      icon: 'bi bi-broadcast',
      title: 'Execute live and keep everyone aligned',
      description: `Run live navigation, track movement, trigger reminders, surface notifications, and collaborate through invites and role-based access as the operation evolves.`,
      outcome: 'Decisions happen faster because the right information is already in front of the right people.'
    }
  ];

  readonly adoptionMoments: string[] = [
    'The dashboard starts showing what needs attention before your team has to ask for status updates.',
    'Checklists, reminders, and worklogs begin replacing memory-driven operations with repeatable execution.',
    'Your route planning, onboard manifests, and navigation records start living in the same workflow instead of separate tools.',
    'As more vessels or more people come in, the structure scales instead of collapsing under complexity.'
  ];
}
